import { useNavigate } from "react-router-dom";
import { ContenedorAnuncios } from "./ContenedorAnuncios";
import ContenedorProgreso from "./ContenedorProgreso";
import "./ContenidoTablon.css";

export const ContenidoTablon = ({ redireccion }) => {
  const navigate = useNavigate();

  return (
    <main className="discussion-page">
      <section className="discussion-hero">
        <div>
          <span className="discussion-eyebrow">Comunidad del curso</span>
          <h1>Foro de discusión</h1>
          <p>Comparte ideas, plantea preguntas y participa en las conversaciones de tu clase.</p>
        </div>
        <div className="discussion-hero-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M4 5.5h16v10H9l-5 4v-14Z"/><path d="M8 9h8M8 12h5"/></svg>
        </div>
      </section>

      <div className="discussion-layout">
        <section className="discussion-main" aria-label="Publicaciones del foro">
          <ContenedorAnuncios />
        </section>

        <aside className="discussion-aside">
          <section className="discussion-side-card">
            <span className="discussion-side-label">Tu avance</span>
            <ContenedorProgreso />
          </section>
          <section className="discussion-side-card">
            <span className="discussion-side-label">Sesiones en vivo</span>
            <h2>Ligas de Zoom</h2>
            <p>Consulta las reuniones programadas para esta clase.</p>
            <button type="button" className="discussion-zoom-button" onClick={() => navigate(`/${redireccion}`)}>
              Ver ligas de Zoom
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>
            </button>
          </section>
        </aside>
      </div>
    </main>
  );
};
